import { VARIABLE_NAMES, getEnvVariable } from "lib/environment";

export const JAZZHR_BASE_URL = getEnvVariable(VARIABLE_NAMES.JAZZHR_BASE_URL);
